import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Téléverser / uploader — flèche montante avec plateau duotone */
export const UploadIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Plateau de dépose menthe */}
      <path d="M3 20.5h18V17H3z" fill="var(--equiply-icon-bg)" />
      {/* Flèche montante */}
      <path d="M12 4v12M7 9l5-5 5 5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      {/* Base */}
      <path d="M3 17h18M3 17v3.5h18V17" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
);
UploadIcon.displayName = "UploadIcon";
